module.exports = __webpack_public_path__ + "static/media/edek7.10503fca.png";